import { render, staticRenderFns } from "./PaginaInformacionContacto.vue?vue&type=template&id=32b46e03&scoped=true&"
import script from "./PaginaInformacionContacto.vue?vue&type=script&lang=js&"
export * from "./PaginaInformacionContacto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b46e03",
  null
  
)

export default component.exports